/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<6cc92d1d94df833831928b3dcf2cd633>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type portal_HelpCenterPortal$data = {
  readonly description: string | null | undefined;
  readonly logo: string | null | undefined;
  readonly name: string;
  readonly portalId: string | null | undefined;
  readonly " $fragmentType": "portal_HelpCenterPortal";
};
export type portal_HelpCenterPortal$key = {
  readonly " $data"?: portal_HelpCenterPortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"portal_HelpCenterPortal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "portal_HelpCenterPortal",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalId",
      "storageKey": null
    }
  ],
  "type": "HelpLayoutPortalCard",
  "abstractKey": null
};

(node as any).hash = "3799a41c8f97aa60a39e5e30cebbea7b";

export default node;
